import { autoVeloSiteCallForAMethod } from '@wix/bi-logger-auto-velo/v2';
import { itemUploadCallback as universalItemUploadCallback, generateFileUploadUrl as universalGenerateFileUploadUrl, importFile as universalImportFile, searchItems as universalSearchItems, queryItems as universalQueryItems, updateItem as universalUpdateItem, bulkUpdateItem as universalBulkUpdateItem, getItem as universalGetItem, linkItemToCategories as universalLinkItemToCategories, unlinkItemFromCategories as universalUnlinkItemFromCategories, overwriteItemCategories as universalOverwriteItemCategories, } from './media-enterprise-public-media-v1-enterprise-item.universal';
import { MediaType, PublishStatus, SortOrder, WebhookIdentityType, } from './media-enterprise-public-media-v1-enterprise-item.universal';
function wrapSideEffect(sideEffect) {
    return (...args) => {
        try {
            sideEffect(...args);
        }
        catch (e) {
            // add some kind of log?
        }
    };
}
function createSideEffects(sideEffects) {
    return Object.entries(sideEffects).reduce((acc, [key, value]) => {
        acc[key] = wrapSideEffect(value);
        return acc;
    }, {});
}
function createVeloSiteCallLogData(params) {
    return autoVeloSiteCallForAMethod(Object.assign({ environment: 'front-end', entity_name: 'wix.media.enterprise_public_media.v1.enterprise_item', module_name: 'wix-media.v2' }, params));
}
export function sdkFactory({ appEssentials }) {
    const httpClient = appEssentials.httpClient;
    const logger = appEssentials
        .biLoggerFactory({ endpoint: 'auto-velo' })
        .logger();
    return {
        itemUploadCallback: (options) => {
            const methodLogData = {
                method_name: 'itemUploadCallback',
                service_name: 'com.wix.media.enterprise_public_media.v1.EnterpriseItemsService',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-media.v2,entity=wix.media.enterprise_public_media.v1.enterprise_item,environment=velo-frontend,method-fqn=com.wix.media.enterprise_public_media.v1.EnterpriseItemsService.itemUploadCallback',
            };
            return universalItemUploadCallback(options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        generateFileUploadUrl: (options) => {
            const methodLogData = {
                method_name: 'generateFileUploadUrl',
                service_name: 'com.wix.media.enterprise_public_media.v1.EnterpriseItemsService',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-media.v2,entity=wix.media.enterprise_public_media.v1.enterprise_item,environment=velo-frontend,method-fqn=com.wix.media.enterprise_public_media.v1.EnterpriseItemsService.generateFileUploadUrl',
            };
            return universalGenerateFileUploadUrl(options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        importFile: (url, options) => {
            const methodLogData = {
                method_name: 'importFile',
                service_name: 'com.wix.media.enterprise_public_media.v1.EnterpriseItemsService',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-media.v2,entity=wix.media.enterprise_public_media.v1.enterprise_item,environment=velo-frontend,method-fqn=com.wix.media.enterprise_public_media.v1.EnterpriseItemsService.importFile',
            };
            return universalImportFile(url, options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        searchItems: (options) => {
            const methodLogData = {
                method_name: 'searchItems',
                service_name: 'com.wix.media.enterprise_public_media.v1.EnterpriseItemsService',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-media.v2,entity=wix.media.enterprise_public_media.v1.enterprise_item,environment=velo-frontend,method-fqn=com.wix.media.enterprise_public_media.v1.EnterpriseItemsService.searchItems',
            };
            return universalSearchItems(options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        queryItems: () => {
            const methodLogData = {
                method_name: 'queryItems',
                service_name: 'com.wix.media.enterprise_public_media.v1.EnterpriseItemsService',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-media.v2,entity=wix.media.enterprise_public_media.v1.enterprise_item,environment=velo-frontend,method-fqn=com.wix.media.enterprise_public_media.v1.EnterpriseItemsService.queryItems',
            };
            return universalQueryItems(
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        updateItem: (_id, item, options) => {
            const methodLogData = {
                method_name: 'updateItem',
                service_name: 'com.wix.media.enterprise_public_media.v1.EnterpriseItemsService',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-media.v2,entity=wix.media.enterprise_public_media.v1.enterprise_item,environment=velo-frontend,method-fqn=com.wix.media.enterprise_public_media.v1.EnterpriseItemsService.updateItem',
            };
            return universalUpdateItem(_id, item, options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        bulkUpdateItem: (updateItemRequests, options) => {
            const methodLogData = {
                method_name: 'bulkUpdateItem',
                service_name: 'com.wix.media.enterprise_public_media.v1.EnterpriseItemsService',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-media.v2,entity=wix.media.enterprise_public_media.v1.enterprise_item,environment=velo-frontend,method-fqn=com.wix.media.enterprise_public_media.v1.EnterpriseItemsService.bulkUpdateItem',
            };
            return universalBulkUpdateItem(updateItemRequests, options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        getItem: (itemId) => {
            const methodLogData = {
                method_name: 'getItem',
                service_name: 'com.wix.media.enterprise_public_media.v1.EnterpriseItemsService',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-media.v2,entity=wix.media.enterprise_public_media.v1.enterprise_item,environment=velo-frontend,method-fqn=com.wix.media.enterprise_public_media.v1.EnterpriseItemsService.getItem',
            };
            return universalGetItem(itemId, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        linkItemToCategories: (itemId, options) => {
            const methodLogData = {
                method_name: 'linkItemToCategories',
                service_name: 'com.wix.media.enterprise_public_media.v1.EnterpriseItemsService',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-media.v2,entity=wix.media.enterprise_public_media.v1.enterprise_item,environment=velo-frontend,method-fqn=com.wix.media.enterprise_public_media.v1.EnterpriseItemsService.linkItemToCategories',
            };
            return universalLinkItemToCategories(itemId, options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        unlinkItemFromCategories: (itemId, options) => {
            const methodLogData = {
                method_name: 'unlinkItemFromCategories',
                service_name: 'com.wix.media.enterprise_public_media.v1.EnterpriseItemsService',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-media.v2,entity=wix.media.enterprise_public_media.v1.enterprise_item,environment=velo-frontend,method-fqn=com.wix.media.enterprise_public_media.v1.EnterpriseItemsService.unlinkItemFromCategories',
            };
            return universalUnlinkItemFromCategories(itemId, options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        overwriteItemCategories: (itemId, options) => {
            const methodLogData = {
                method_name: 'overwriteItemCategories',
                service_name: 'com.wix.media.enterprise_public_media.v1.EnterpriseItemsService',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-media.v2,entity=wix.media.enterprise_public_media.v1.enterprise_item,environment=velo-frontend,method-fqn=com.wix.media.enterprise_public_media.v1.EnterpriseItemsService.overwriteItemCategories',
            };
            return universalOverwriteItemCategories(itemId, options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        MediaType,
        PublishStatus,
        SortOrder,
        WebhookIdentityType,
    };
}
//# sourceMappingURL=media-enterprise-public-media-v1-enterprise-item.frontend.js.map